var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgMenuPathway = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 39.54 39.44",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.77,39.26C9.02,39.26,.27,30.51,.27,19.76S9.02,.26,19.77,.26s19.5,8.75,19.5,19.5-8.75,19.5-19.5,19.5ZM19.77,1.26C9.57,1.26,1.27,9.56,1.27,19.76s8.3,18.5,18.5,18.5,18.5-8.3,18.5-18.5S29.97,1.26,19.77,1.26Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.44,12.2h2.33c.39,0,.77,.09,1.13,.26,1.92,.93,7.91,4.24,3.96,7.83-2.46,2.24-2.75,3.45-1.85,4.58,.22,.27,.02,.67-.33,.67H13.23c-.26,0-.46-.23-.41-.49,.29-1.5,1.34-4.03,5.08-5.07,0,0,4.41-1.37,3.24-4.06-.41-.94-1.45-1.79-2.95-2.96-.31-.24-.15-.75,.25-.75Z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMenuPathway, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Menu_Pathway.549cac65.svg";
export { ForwardRef as ReactComponent };